// Source: 'Top 100 DACH' sheet from Top 50 Logistikunternehmen in Europa 2025.xlsx.
// Workflow status, onboarding progress, dates, and logos are added separately as demo data.
export const europeanCarrierDirectory = [
    {
        "id": 1,
        "rank": 1,
        "name": "DHL Group (DHL Freight / Express)",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Bonn",
        "roadCargoFocus": "FTL, LTL, Stückgut, KEP",
        "estimatedRevenueMillionEur": 81800.0,
        "website": "dhl.com",
        "contacts": []
    },
    {
        "id": 2,
        "rank": 2,
        "name": "DSV / DB Schenker",
        "country": "DE",
        "countryName": "Deutschland / Dänemark",
        "headquarters": "Essen / Bremen",
        "roadCargoFocus": "FTL, LTL, Systemverkehr, Kontraktlogistik",
        "estimatedRevenueMillionEur": 52600.0,
        "website": "dbschenker.com / dsv.com",
        "contacts": [
            {
                "email": "nathalie.viufstender@dsv.com",
                "linkedin": "https://www.linkedin.com/in/nathalie-viuf-stender-89037984/"
            },
            {
                "email": "michael.jasper@dsv.com",
                "linkedin": "https://www.linkedin.com/in/michaeljasper1/"
            },
            {
                "email": "nadine.siemes@dsv.com",
                "linkedin": "https://www.linkedin.com/in/nadine-siemes-5a21b3206/"
            }
        ]
    },
    {
        "id": 3,
        "rank": 3,
        "name": "Kuehne + Nagel",
        "country": "CH",
        "countryName": "Schweiz",
        "headquarters": "Schindellegi",
        "roadCargoFocus": "FTL, LTL, Kontraktlogistik",
        "estimatedRevenueMillionEur": 27500.0,
        "website": "kuehne-nagel.com",
        "contacts": [
            {
                "email": "daniel.maier-johnson@kuehne-nagel.com",
                "linkedin": "https://www.linkedin.com/in/dmaierjohnson/"
            },
            {
                "email": "alireza.nemati@kuehne-nagel.com",
                "linkedin": "https://www.linkedin.com/in/nematialireza/"
            },
            {
                "email": "christoph.zulauf@kuehne-nagel.com",
                "linkedin": "https://www.linkedin.com/in/christoph-zulauf-648648182/"
            }
        ]
    },
    {
        "id": 4,
        "rank": 4,
        "name": "Dachser Group",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Kempten",
        "roadCargoFocus": "Stückgut, Systemverkehr, FTL",
        "estimatedRevenueMillionEur": 7100.0,
        "website": "dachser.com",
        "contacts": []
    },
    {
        "id": 5,
        "rank": 5,
        "name": "Rhenus Logistics",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Holzwickede",
        "roadCargoFocus": "FTL, LTL, Kontraktlogistik",
        "estimatedRevenueMillionEur": 7500.0,
        "website": "rhenus.com",
        "contacts": [
            {
                "email": "carsten.bayer@rhenus.com",
                "linkedin": "https://www.linkedin.com/in/carsten-bayer-infosec/"
            },
            {
                "email": "lorenz.brakel@rhenus.com",
                "linkedin": "https://www.linkedin.com/in/lorenz-brakel-958122253/"
            },
            {
                "email": "nico.luebbert@rhenus.com",
                "linkedin": "https://www.linkedin.com/in/nico-l%C3%BCbbert-054a00361/"
            }
        ]
    },
    {
        "id": 6,
        "rank": 6,
        "name": "LKW WALTER",
        "country": "AT",
        "countryName": "Österreich",
        "headquarters": "Wiener Neudorf",
        "roadCargoFocus": "FTL (Komplettladungen)",
        "estimatedRevenueMillionEur": 3100.0,
        "website": "lkw-walter.com",
        "contacts": [
            {
                "email": "senad@lkwwalter.com",
                "linkedin": "https://www.linkedin.com/in/senad-basic-2b417141/"
            },
            {
                "email": "greuter@lkw-walter.com",
                "linkedin": "https://www.linkedin.com/in/simon-greuter-6436b0133"
            },
            {
                "email": "bell@lkw-walter.com",
                "linkedin": "https://www.linkedin.com/in/aaron-michael-bell/"
            }
        ]
    },
    {
        "id": 7,
        "rank": 7,
        "name": "Gebrüder Weiss",
        "country": "AT",
        "countryName": "Österreich",
        "headquarters": "Lauterach",
        "roadCargoFocus": "Landverkehr, Stückgut, FTL",
        "estimatedRevenueMillionEur": 2470.0,
        "website": "gw-world.com",
        "contacts": [
            {
                "email": "bernhard.heinzle@gw-world.com",
                "linkedin": "https://www.linkedin.com/in/bernhard-heinzle/"
            },
            {
                "email": "mike.mehnert@gw-world.com",
                "linkedin": "https://www.linkedin.com/in/mike-mehnert-1770171b3"
            },
            {
                "email": "goran.susak@gw-world.com",
                "linkedin": "https://www.linkedin.com/in/goran-susak-8b662269/"
            }
        ]
    },
    {
        "id": 8,
        "rank": 8,
        "name": "Hellmann Worldwide Logistics",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Osnabrück",
        "roadCargoFocus": "FTL, LTL, Stückgut",
        "estimatedRevenueMillionEur": 3500.0,
        "website": "hellmann.com",
        "contacts": [
            {
                "email": "helmut.koers@hellmann.com",
                "linkedin": "https://www.linkedin.com/in/helmut-koers-07915629b/"
            },
            {
                "email": "martin.dedik@hellmann.com",
                "linkedin": "https://www.linkedin.com/in/martin-ded%C3%ADk-bbbbb519/"
            },
            {
                "email": "yuliia.lashko@hellmann.com",
                "linkedin": "https://www.linkedin.com/in/yuliia-lashko-6b3054257/"
            }
        ]
    },
    {
        "id": 9,
        "rank": 9,
        "name": "Fiege Logistik",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Greven",
        "roadCargoFocus": "Kontraktlogistik, Road Cargo",
        "estimatedRevenueMillionEur": 2000.0,
        "website": "fiege.com",
        "contacts": [
            {
                "email": "friederike.merdan@fiege.com",
                "linkedin": "https://www.linkedin.com/in/friederike-merdan/"
            },
            {
                "email": "timo.bularczyk@fiege.com",
                "linkedin": "https://www.linkedin.com/in/timobu/"
            },
            {
                "email": "henning.off@fiege.com",
                "linkedin": "https://www.linkedin.com/in/henning-off-4064731ba"
            }
        ]
    },
    {
        "id": 10,
        "rank": 10,
        "name": "Hermes Germany (Otto Group)",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Hamburg",
        "roadCargoFocus": "KEP / Paketlogistik",
        "estimatedRevenueMillionEur": 3800.0,
        "website": "hermesworld.com",
        "contacts": []
    },
    {
        "id": 11,
        "rank": 11,
        "name": "DPD Deutschland / GeoPost",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Aschaffenburg",
        "roadCargoFocus": "KEP / Paketdienst",
        "estimatedRevenueMillionEur": 2300.0,
        "website": "dpd.de",
        "contacts": []
    },
    {
        "id": 12,
        "rank": 12,
        "name": "GLS Germany",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Neuenstein",
        "roadCargoFocus": "Paket, Express, Road",
        "estimatedRevenueMillionEur": 1400.0,
        "website": "gls-group.eu",
        "contacts": [
            {
                "email": "joachim.fritschi@gls-group.com",
                "linkedin": "https://www.linkedin.com/in/joachim-fritschi/"
            },
            {
                "email": "tommaso.marinelli@gls-group.com",
                "linkedin": "https://www.linkedin.com/in/tommaso-marinelli1"
            },
            {
                "email": "shuzhe.yang@gls-group.com",
                "linkedin": "https://www.linkedin.com/in/shuzheyang"
            }
        ]
    },
    {
        "id": 13,
        "rank": 13,
        "name": "UPS Germany / Europe",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Neuss",
        "roadCargoFocus": "Express, Paket, Road Cargo",
        "estimatedRevenueMillionEur": 2800.0,
        "website": "ups.com",
        "contacts": [
            {
                "email": "ltodt@ups.com",
                "linkedin": "https://www.linkedin.com/in/lars-todt-050539141"
            },
            {
                "email": "dveliagic@ups.com",
                "linkedin": "https://www.linkedin.com/in/dennis-veliagic-919212389"
            },
            {
                "email": "motto@ups.com",
                "linkedin": "https://www.linkedin.com/in/michael-otto-38617911b"
            }
        ]
    },
    {
        "id": 14,
        "rank": 14,
        "name": "Planzer Transport",
        "country": "CH",
        "countryName": "Schweiz",
        "headquarters": "Dietikon",
        "roadCargoFocus": "Stückgut, FTL, LTL",
        "estimatedRevenueMillionEur": 1100.0,
        "website": "planzer.ch",
        "contacts": [
            {
                "email": "ojenn@planzer.ch",
                "linkedin": "https://www.linkedin.com/in/olivier-jenn-bb34a1111/"
            },
            {
                "email": "blindner@planzer.ch",
                "linkedin": "https://www.linkedin.com/in/bj%C3%B6rn-lindner-20835510/"
            },
            {
                "email": "flopresti@planzer.ch",
                "linkedin": "https://www.linkedin.com/in/fabio-lo-presti-58b4b9159/"
            }
        ]
    },
    {
        "id": 15,
        "rank": 15,
        "name": "Lagermax Group",
        "country": "AT",
        "countryName": "Österreich",
        "headquarters": "Salzburg",
        "roadCargoFocus": "Landverkehr, Autotransport, Express",
        "estimatedRevenueMillionEur": 700.0,
        "website": "lagermax.com",
        "contacts": []
    },
    {
        "id": 16,
        "rank": 16,
        "name": "Galliker Transport",
        "country": "CH",
        "countryName": "Schweiz",
        "headquarters": "Altishofen",
        "roadCargoFocus": "Transport, Kühllogistik, FTL",
        "estimatedRevenueMillionEur": 650.0,
        "website": "galliker.com",
        "contacts": [
            {
                "email": "roger.salathe@galliker.com",
                "linkedin": "https://www.linkedin.com/in/roger-salathe-2a430821b/"
            },
            {
                "email": "philipp.straessle@galliker.com",
                "linkedin": "https://www.linkedin.com/in/philipp-str%C3%A4ssle-613453162/"
            },
            {
                "email": "nikola.mihajlovic@galliker.com",
                "linkedin": "https://www.linkedin.com/in/nikola-mihajlovic-8a34963a9/"
            }
        ]
    },
    {
        "id": 17,
        "rank": 17,
        "name": "Raben Group Germany",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Polch",
        "roadCargoFocus": "Stückgut, FTL, LTL",
        "estimatedRevenueMillionEur": 2000.0,
        "website": "raben-group.com",
        "contacts": [
            {
                "email": "piotr.sowa@raben-group.com",
                "linkedin": "https://www.linkedin.com/in/ignatus-pl/"
            },
            {
                "email": "piotr.jozefczyk@raben-group.com",
                "linkedin": "https://www.linkedin.com/in/piotrjozefczyk/"
            },
            {
                "email": "stephan.frank@raben-group.com",
                "linkedin": "https://www.linkedin.com/in/stephan-frank-040913147/"
            }
        ]
    },
    {
        "id": 18,
        "rank": 18,
        "name": "Emons Spedition",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Köln",
        "roadCargoFocus": "Transport, Stückgut, LTL",
        "estimatedRevenueMillionEur": 680.0,
        "website": "emons.de",
        "contacts": []
    },
    {
        "id": 19,
        "rank": 19,
        "name": "Quehenberger Logistics",
        "country": "AT",
        "countryName": "Österreich",
        "headquarters": "Straßwalchen",
        "roadCargoFocus": "Landverkehr, FTL, LTL",
        "estimatedRevenueMillionEur": 650.0,
        "website": "quehenberger.com",
        "contacts": [
            {
                "email": "guelsen.aksoy@quehenberger.com",
                "linkedin": "https://www.linkedin.com/in/g%C3%BClsen-aksoy-66b326158/"
            }
        ]
    },
    {
        "id": 20,
        "rank": 20,
        "name": "Arvato Supply Chain Solutions",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Gütersloh",
        "roadCargoFocus": "SCM, Road Transport",
        "estimatedRevenueMillionEur": 2500.0,
        "website": "arvato-supply-chain.com",
        "contacts": []
    },
    {
        "id": 21,
        "rank": 21,
        "name": "Noerpel-Gruppe",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Ulm",
        "roadCargoFocus": "Stückgut, FTL, LTL",
        "estimatedRevenueMillionEur": 600.0,
        "website": "noerpel.de",
        "contacts": []
    },
    {
        "id": 22,
        "rank": 22,
        "name": "Geis Gruppe",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Bad Neustadt a. d. Saale",
        "roadCargoFocus": "Road Services, Stückgut",
        "estimatedRevenueMillionEur": 1300.0,
        "website": "geis-group.com",
        "contacts": []
    },
    {
        "id": 23,
        "rank": 23,
        "name": "Sieber Transport",
        "country": "CH",
        "countryName": "Schweiz",
        "headquarters": "Berneck",
        "roadCargoFocus": "Stückgut, FTL",
        "estimatedRevenueMillionEur": 250.0,
        "website": "sieber.ch",
        "contacts": []
    },
    {
        "id": 24,
        "rank": 24,
        "name": "C.H. Robinson Europe",
        "country": "DE",
        "countryName": "Deutschland / NL",
        "headquarters": "München / Amsterdam",
        "roadCargoFocus": "Frachtvermittlung, FTL",
        "estimatedRevenueMillionEur": 2200.0,
        "website": "chrobinson.com",
        "contacts": []
    },
    {
        "id": 25,
        "rank": 25,
        "name": "Duvenbeck Unternehmensgruppe",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Bocholt",
        "roadCargoFocus": "Automotive FTL, LTL",
        "estimatedRevenueMillionEur": 800.0,
        "website": "duvenbeck.de",
        "contacts": []
    },
    {
        "id": 26,
        "rank": 26,
        "name": "CargoLine Network",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Frankfurt am Main",
        "roadCargoFocus": "Stückgutkooperation",
        "estimatedRevenueMillionEur": 1500.0,
        "website": "cargoline.de",
        "contacts": []
    },
    {
        "id": 27,
        "rank": 27,
        "name": "24plus Systemlogistik",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Hauneck",
        "roadCargoFocus": "Stückgutnetzwerk",
        "estimatedRevenueMillionEur": 850.0,
        "website": "24plus.de",
        "contacts": []
    },
    {
        "id": 28,
        "rank": 28,
        "name": "Schober Transport",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Ditzingen",
        "roadCargoFocus": "Temperaturgeführter Road Transport",
        "estimatedRevenueMillionEur": 220.0,
        "website": "schober-logistik.de",
        "contacts": []
    },
    {
        "id": 29,
        "rank": 29,
        "name": "FINK BEBO (Fink Logistik)",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Sachsenheim",
        "roadCargoFocus": "Automotive, Road Transport",
        "estimatedRevenueMillionEur": 120.0,
        "website": "fink-logistik.de",
        "contacts": []
    },
    {
        "id": 30,
        "rank": 30,
        "name": "Koch International",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Osnabrück",
        "roadCargoFocus": "Road Cargo, LTL, FTL",
        "estimatedRevenueMillionEur": 180.0,
        "website": "koch-international.de",
        "contacts": []
    },
    {
        "id": 31,
        "rank": 31,
        "name": "HONOLD Logistik Gruppe",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Neu-Ulm",
        "roadCargoFocus": "FTL, LTL, Kontraktlogistik",
        "estimatedRevenueMillionEur": 250.0,
        "website": "honold.net",
        "contacts": []
    },
    {
        "id": 32,
        "rank": 32,
        "name": "Bertschi AG",
        "country": "CH",
        "countryName": "Schweiz",
        "headquarters": "Dürrenäsch",
        "roadCargoFocus": "Chemielogistik, Tankcontainer, Road",
        "estimatedRevenueMillionEur": 1100.0,
        "website": "bertschi.com",
        "contacts": []
    },
    {
        "id": 33,
        "rank": 33,
        "name": "Waberer’s Deutschland",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "München",
        "roadCargoFocus": "FTL-Fernverkehr",
        "estimatedRevenueMillionEur": 700.0,
        "website": "waberers.com",
        "contacts": []
    },
    {
        "id": 34,
        "rank": 34,
        "name": "Gefco / CEVA Logistics",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Mörfelden-Walldorf",
        "roadCargoFocus": "Automotive, Road Cargo",
        "estimatedRevenueMillionEur": 600.0,
        "website": "ceva-logistics.com",
        "contacts": []
    },
    {
        "id": 35,
        "rank": 35,
        "name": "Camion Transport",
        "country": "CH",
        "countryName": "Schweiz",
        "headquarters": "Wil",
        "roadCargoFocus": "Stückgut, Strassentransport",
        "estimatedRevenueMillionEur": 320.0,
        "website": "camiontransport.ch",
        "contacts": []
    },
    {
        "id": 36,
        "rank": 36,
        "name": "Fercam AG",
        "country": "DE",
        "countryName": "Deutschland / Italien",
        "headquarters": "München / Bozen",
        "roadCargoFocus": "FTL, LTL, Stückgut",
        "estimatedRevenueMillionEur": 1100.0,
        "website": "fercam.com",
        "contacts": []
    },
    {
        "id": 37,
        "rank": 37,
        "name": "Kobernuss Spedition",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Uelzen",
        "roadCargoFocus": "FTL, LTL Spedition",
        "estimatedRevenueMillionEur": 90.0,
        "website": "kobernuss.de",
        "contacts": []
    },
    {
        "id": 38,
        "rank": 38,
        "name": "Röhlich Spedition",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Freiberg",
        "roadCargoFocus": "Transport, Road Cargo",
        "estimatedRevenueMillionEur": 75.0,
        "website": "roehlich.de",
        "contacts": []
    },
    {
        "id": 39,
        "rank": 39,
        "name": "BGL Speditions-Verbund",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Frankfurt am Main",
        "roadCargoFocus": "Transport, Stückgut",
        "estimatedRevenueMillionEur": 500.0,
        "website": "bgl-ev.de",
        "contacts": []
    },
    {
        "id": 40,
        "rank": 40,
        "name": "Barth Logistics",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Burladingen",
        "roadCargoFocus": "Systemverkehr, FTL",
        "estimatedRevenueMillionEur": 110.0,
        "website": "barth-logistik.de",
        "contacts": []
    },
    {
        "id": 41,
        "rank": 41,
        "name": "Schockemöhle Logistics",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Steinfeld",
        "roadCargoFocus": "FTL, LTL, Transport",
        "estimatedRevenueMillionEur": 160.0,
        "website": "schockemoehle.de",
        "contacts": []
    },
    {
        "id": 42,
        "rank": 42,
        "name": "Seifert Logistics Group",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Ulm",
        "roadCargoFocus": "Road Cargo, Kontraktlogistik",
        "estimatedRevenueMillionEur": 290.0,
        "website": "seifert-logistics.com",
        "contacts": []
    },
    {
        "id": 43,
        "rank": 43,
        "name": "Klumpp + Müller",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Kehl",
        "roadCargoFocus": "Intermodal, Road Cargo",
        "estimatedRevenueMillionEur": 85.0,
        "website": "klumpp-mueller.de",
        "contacts": []
    },
    {
        "id": 44,
        "rank": 44,
        "name": "Bischof Transport",
        "country": "AT",
        "countryName": "Österreich",
        "headquarters": "Feldkirch",
        "roadCargoFocus": "FTL, LTL Transport",
        "estimatedRevenueMillionEur": 95.0,
        "website": "bischof-trans.at",
        "contacts": []
    },
    {
        "id": 45,
        "rank": 45,
        "name": "Wenzel Logistik",
        "country": "AT",
        "countryName": "Österreich",
        "headquarters": "Unterradlberg",
        "roadCargoFocus": "FTL, LTL Road Cargo",
        "estimatedRevenueMillionEur": 80.0,
        "website": "wenzel-logistik.at",
        "contacts": []
    },
    {
        "id": 46,
        "rank": 46,
        "name": "Nothegger Transport Logistik",
        "country": "AT",
        "countryName": "Österreich",
        "headquarters": "St. Ulrich",
        "roadCargoFocus": "FTL, LTL Transport",
        "estimatedRevenueMillionEur": 190.0,
        "website": "nothegger.at",
        "contacts": []
    },
    {
        "id": 47,
        "rank": 47,
        "name": "Gartner KG",
        "country": "AT",
        "countryName": "Österreich",
        "headquarters": "Edt bei Lambach",
        "roadCargoFocus": "FTL, Straßengüterverkehr",
        "estimatedRevenueMillionEur": 620.0,
        "website": "gartnerkg.com",
        "contacts": []
    },
    {
        "id": 48,
        "rank": 48,
        "name": "Siegl Spedition",
        "country": "AT",
        "countryName": "Österreich",
        "headquarters": "Wien",
        "roadCargoFocus": "Transport, Road Cargo",
        "estimatedRevenueMillionEur": 45.0,
        "website": "spedition-siegl.at",
        "contacts": []
    },
    {
        "id": 49,
        "rank": 49,
        "name": "KREISS Logistik",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Bad Bentheim",
        "roadCargoFocus": "FTL, Thermo Transport",
        "estimatedRevenueMillionEur": 140.0,
        "website": "kreiss.de",
        "contacts": []
    },
    {
        "id": 50,
        "rank": 50,
        "name": "Senn AG",
        "country": "CH",
        "countryName": "Schweiz",
        "headquarters": "Oftringen",
        "roadCargoFocus": "Schwergut, Transport",
        "estimatedRevenueMillionEur": 110.0,
        "website": "sennag.ch",
        "contacts": []
    },
    {
        "id": 51,
        "rank": 51,
        "name": "Streck Transport",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Lörrach",
        "roadCargoFocus": "Stückgut, Road Cargo",
        "estimatedRevenueMillionEur": 280.0,
        "website": "streck-transport.com",
        "contacts": []
    },
    {
        "id": 52,
        "rank": 52,
        "name": "Logistik-Gruppe Zufall",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Göttingen",
        "roadCargoFocus": "Road Cargo, Stückgut",
        "estimatedRevenueMillionEur": 360.0,
        "website": "zufall.de",
        "contacts": []
    },
    {
        "id": 53,
        "rank": 53,
        "name": "Bischoff Spedition",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Burgstädt",
        "roadCargoFocus": "FTL, LTL Transport",
        "estimatedRevenueMillionEur": 65.0,
        "website": "spedition-bischoff.de",
        "contacts": []
    },
    {
        "id": 54,
        "rank": 54,
        "name": "Pfenning Logistics",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Heddesheim",
        "roadCargoFocus": "Kontraktlogistik, Road Freight",
        "estimatedRevenueMillionEur": 270.0,
        "website": "pfenning-logistics.com",
        "contacts": []
    },
    {
        "id": 55,
        "rank": 55,
        "name": "Dietrich Spedition",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Offenbach",
        "roadCargoFocus": "Spedition, Road Cargo",
        "estimatedRevenueMillionEur": 95.0,
        "website": "dietrich-logistik.de",
        "contacts": []
    },
    {
        "id": 56,
        "rank": 56,
        "name": "Willers Logistics",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Münster",
        "roadCargoFocus": "Transport, FTL",
        "estimatedRevenueMillionEur": 50.0,
        "website": "willers-logistics.de",
        "contacts": []
    },
    {
        "id": 57,
        "rank": 57,
        "name": "Schneider Spedition",
        "country": "CH",
        "countryName": "Schweiz",
        "headquarters": "Basel",
        "roadCargoFocus": "Internationale Spedition",
        "estimatedRevenueMillionEur": 180.0,
        "website": "schneider-transport.com",
        "contacts": []
    },
    {
        "id": 58,
        "rank": 58,
        "name": "H.Essers Germany",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Kamp-Lintfort",
        "roadCargoFocus": "Chemie, Pharma Road Cargo",
        "estimatedRevenueMillionEur": 1100.0,
        "website": "essers.com",
        "contacts": []
    },
    {
        "id": 59,
        "rank": 59,
        "name": "Schmidt-Gevelsberg",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Schwelm",
        "roadCargoFocus": "Stückgut, Road Freight",
        "estimatedRevenueMillionEur": 130.0,
        "website": "schmidt-gevelsberg.de",
        "contacts": []
    },
    {
        "id": 60,
        "rank": 60,
        "name": "Rhenus Freight Road",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Holzwickede",
        "roadCargoFocus": "Straßennetzwerk, FTL/LTL",
        "estimatedRevenueMillionEur": 1200.0,
        "website": "rhenus.group",
        "contacts": []
    },
    {
        "id": 61,
        "rank": 61,
        "name": "Meyer & Meyer",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Osnabrück",
        "roadCargoFocus": "Fashion Logistics, Road",
        "estimatedRevenueMillionEur": 190.0,
        "website": "meyer-meyer.com",
        "contacts": []
    },
    {
        "id": 62,
        "rank": 62,
        "name": "Voss International",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Jederitz",
        "roadCargoFocus": "FTL, LTL Transport",
        "estimatedRevenueMillionEur": 40.0,
        "website": "voss-international.de",
        "contacts": []
    },
    {
        "id": 63,
        "rank": 63,
        "name": "Schwenk Transport",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Schwieberdingen",
        "roadCargoFocus": "Spezialtransport, Road",
        "estimatedRevenueMillionEur": 35.0,
        "website": "schwenk-logistik.de",
        "contacts": []
    },
    {
        "id": 64,
        "rank": 64,
        "name": "Ewals Cargo Care Germany",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Duisburg",
        "roadCargoFocus": "FTL, Intermodal Transport",
        "estimatedRevenueMillionEur": 800.0,
        "website": "ewals.com",
        "contacts": []
    },
    {
        "id": 65,
        "rank": 65,
        "name": "Reder Transport",
        "country": "AT",
        "countryName": "Österreich",
        "headquarters": "Hörsching",
        "roadCargoFocus": "FTL, LTL Transport",
        "estimatedRevenueMillionEur": 110.0,
        "website": "reder.at",
        "contacts": []
    },
    {
        "id": 66,
        "rank": 66,
        "name": "Kieserling Logistik",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Bremen",
        "roadCargoFocus": "Hafen, Road Transport",
        "estimatedRevenueMillionEur": 90.0,
        "website": "kieserling.de",
        "contacts": []
    },
    {
        "id": 67,
        "rank": 67,
        "name": "Augustin Network",
        "country": "AT",
        "countryName": "Österreich",
        "headquarters": "Straßwalchen",
        "roadCargoFocus": "FTL Transporter",
        "estimatedRevenueMillionEur": 140.0,
        "website": "augustin-network.com",
        "contacts": []
    },
    {
        "id": 68,
        "rank": 68,
        "name": "Fixemer Logistics",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Perl",
        "roadCargoFocus": "FTL Chartering, Road Cargo",
        "estimatedRevenueMillionEur": 450.0,
        "website": "fixemer.com",
        "contacts": []
    },
    {
        "id": 69,
        "rank": 69,
        "name": "Frölich Spedition",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Hessisch Lichtenau",
        "roadCargoFocus": "Transport, Road Cargo",
        "estimatedRevenueMillionEur": 70.0,
        "website": "froelich-spedition.de",
        "contacts": []
    },
    {
        "id": 70,
        "rank": 70,
        "name": "Wormser Transport Logistics",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Herzogenaurach",
        "roadCargoFocus": "Silo, FTL Transport",
        "estimatedRevenueMillionEur": 110.0,
        "website": "wormser.de",
        "contacts": []
    },
    {
        "id": 71,
        "rank": 71,
        "name": "Tchibo Logistics / OSC",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Hamburg",
        "roadCargoFocus": "E-Commerce Road Cargo",
        "estimatedRevenueMillionEur": 200.0,
        "website": "osc-logistics.de",
        "contacts": []
    },
    {
        "id": 72,
        "rank": 72,
        "name": "Bock Spedition",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Neumarkt",
        "roadCargoFocus": "FTL, LTL Transport",
        "estimatedRevenueMillionEur": 55.0,
        "website": "bock-spedition.de",
        "contacts": []
    },
    {
        "id": 73,
        "rank": 73,
        "name": "Ziegler Group Germany",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Düsseldorf",
        "roadCargoFocus": "Road Freight, Forwarding",
        "estimatedRevenueMillionEur": 1400.0,
        "website": "zieglergroup.com",
        "contacts": []
    },
    {
        "id": 74,
        "rank": 74,
        "name": "Giezendanner Transport",
        "country": "CH",
        "countryName": "Schweiz",
        "headquarters": "Rothrist",
        "roadCargoFocus": "Tank, Schüttgut Road",
        "estimatedRevenueMillionEur": 95.0,
        "website": "giezendanner-transport.ch",
        "contacts": []
    },
    {
        "id": 75,
        "rank": 75,
        "name": "Imbach Logistik",
        "country": "CH",
        "countryName": "Schweiz",
        "headquarters": "Luzern",
        "roadCargoFocus": "Stückgut, Distribution",
        "estimatedRevenueMillionEur": 85.0,
        "website": "imbach.ch",
        "contacts": []
    },
    {
        "id": 76,
        "rank": 76,
        "name": "Krummen Kerzers",
        "country": "CH",
        "countryName": "Schweiz",
        "headquarters": "Kerzers",
        "roadCargoFocus": "Lebensmittel, FTL Road Cargo",
        "estimatedRevenueMillionEur": 75.0,
        "website": "krummen.ch",
        "contacts": []
    },
    {
        "id": 77,
        "rank": 77,
        "name": "Hugger Spedition",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Aldingen",
        "roadCargoFocus": "Stückgut, Road Freight",
        "estimatedRevenueMillionEur": 45.0,
        "website": "hugger-spedition.de",
        "contacts": []
    },
    {
        "id": 78,
        "rank": 78,
        "name": "Jost Group Germany",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Wegberg",
        "roadCargoFocus": "FTL, LTL Transport",
        "estimatedRevenueMillionEur": 350.0,
        "website": "jostgroup.com",
        "contacts": []
    },
    {
        "id": 79,
        "rank": 79,
        "name": "VTL Vernetzte Transport-Logistik",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Fulda",
        "roadCargoFocus": "Stückgutnetzwerk",
        "estimatedRevenueMillionEur": 160.0,
        "website": "vtl.de",
        "contacts": []
    },
    {
        "id": 80,
        "rank": 80,
        "name": "CTL Cargo Trans Logistik",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Homberg",
        "roadCargoFocus": "Stückgutverbund",
        "estimatedRevenueMillionEur": 140.0,
        "website": "ctl-ag.de",
        "contacts": []
    },
    {
        "id": 81,
        "rank": 81,
        "name": "sennder Technologies",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Berlin",
        "roadCargoFocus": "Digital FTL Brokerage",
        "estimatedRevenueMillionEur": 500.0,
        "website": "sennder.com",
        "contacts": []
    },
    {
        "id": 82,
        "rank": 82,
        "name": "InstaFreight",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Berlin",
        "roadCargoFocus": "Digital Road Freight",
        "estimatedRevenueMillionEur": 80.0,
        "website": "instafreight.com",
        "contacts": []
    },
    {
        "id": 83,
        "rank": 83,
        "name": "Saloodo! (DHL Freight)",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Bonn",
        "roadCargoFocus": "Digital Freight Platform",
        "estimatedRevenueMillionEur": 50.0,
        "website": "saloodo.com",
        "contacts": []
    },
    {
        "id": 84,
        "rank": 84,
        "name": "Loadfox",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "München",
        "roadCargoFocus": "Road Freight Tech",
        "estimatedRevenueMillionEur": 20.0,
        "website": "loadfox.de",
        "contacts": []
    },
    {
        "id": 85,
        "rank": 85,
        "name": "Cargoboard",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Paderborn",
        "roadCargoFocus": "Digital Stückgut",
        "estimatedRevenueMillionEur": 35.0,
        "website": "cargoboard.com",
        "contacts": []
    },
    {
        "id": 86,
        "rank": 86,
        "name": "GO! Express & Logistics",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Bonn",
        "roadCargoFocus": "KEP, Kurier, Express",
        "estimatedRevenueMillionEur": 380.0,
        "website": "general-overnight.com",
        "contacts": []
    },
    {
        "id": 87,
        "rank": 87,
        "name": "Trans-o-flex Express",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Weinheim",
        "roadCargoFocus": "Pharma KEP, Express",
        "estimatedRevenueMillionEur": 550.0,
        "website": "trans-o-flex.com",
        "contacts": []
    },
    {
        "id": 88,
        "rank": 88,
        "name": "night Star Express",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Hünfeld",
        "roadCargoFocus": "Nachtexpress, Road Cargo",
        "estimatedRevenueMillionEur": 190.0,
        "website": "nightstarexpress.de",
        "contacts": []
    },
    {
        "id": 89,
        "rank": 89,
        "name": "Der Kurier",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Neuenstein",
        "roadCargoFocus": "KEP, Express Road",
        "estimatedRevenueMillionEur": 45.0,
        "website": "derkurier.de",
        "contacts": []
    },
    {
        "id": 90,
        "rank": 90,
        "name": "ILN International Logistics Network",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Sinzig",
        "roadCargoFocus": "Stückgutnetzwerk",
        "estimatedRevenueMillionEur": 120.0,
        "website": "iln-net.com",
        "contacts": []
    },
    {
        "id": 91,
        "rank": 91,
        "name": "Spedition Wandt",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Braunschweig",
        "roadCargoFocus": "Schwergut, Road Freight",
        "estimatedRevenueMillionEur": 40.0,
        "website": "wandt.de",
        "contacts": []
    },
    {
        "id": 92,
        "rank": 92,
        "name": "Johann Dettendorfer Spedition",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Nußdorf am Inn",
        "roadCargoFocus": "FTL, LTL Freight",
        "estimatedRevenueMillionEur": 210.0,
        "website": "dettendorfer.de",
        "contacts": []
    },
    {
        "id": 93,
        "rank": 93,
        "name": "Richter Transport",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Großenhain",
        "roadCargoFocus": "Road Cargo, FTL",
        "estimatedRevenueMillionEur": 30.0,
        "website": "richter-transport.de",
        "contacts": []
    },
    {
        "id": 94,
        "rank": 94,
        "name": "Lothar Busch Spedition",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Hückeswagen",
        "roadCargoFocus": "FTL Transport",
        "estimatedRevenueMillionEur": 25.0,
        "website": "busch-spedition.de",
        "contacts": []
    },
    {
        "id": 95,
        "rank": 95,
        "name": "Spedition Bode",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Reinfeld",
        "roadCargoFocus": "Thermo, FTL Freight",
        "estimatedRevenueMillionEur": 85.0,
        "website": "spedition-bode.de",
        "contacts": []
    },
    {
        "id": 96,
        "rank": 96,
        "name": "Greiwer Spedition",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Duisburg",
        "roadCargoFocus": "Schwergut, Road Cargo",
        "estimatedRevenueMillionEur": 35.0,
        "website": "greiwer.de",
        "contacts": []
    },
    {
        "id": 97,
        "rank": 97,
        "name": "Spedition Friedrich",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Rodewisch",
        "roadCargoFocus": "FTL Freight",
        "estimatedRevenueMillionEur": 25.0,
        "website": "spedition-friedrich.de",
        "contacts": []
    },
    {
        "id": 98,
        "rank": 98,
        "name": "Gebrüder Fuchs",
        "country": "DE",
        "countryName": "Deutschland",
        "headquarters": "Haigerloch",
        "roadCargoFocus": "Spedition Road Cargo",
        "estimatedRevenueMillionEur": 30.0,
        "website": "fuchs-spedition.de",
        "contacts": []
    },
    {
        "id": 99,
        "rank": 99,
        "name": "Sennhauser Transport",
        "country": "CH",
        "countryName": "Schweiz",
        "headquarters": "Untervaz",
        "roadCargoFocus": "Kipper, Road Freight",
        "estimatedRevenueMillionEur": 40.0,
        "website": "sennhauser-transport.ch",
        "contacts": []
    },
    {
        "id": 100,
        "rank": 100,
        "name": "Bertschi Global Road",
        "country": "CH",
        "countryName": "Schweiz",
        "headquarters": "Dürrenäsch",
        "roadCargoFocus": "Chemielogistik Straße",
        "estimatedRevenueMillionEur": 400.0,
        "website": "bertschi.com",
        "contacts": []
    }
];

export const getEuropeanCarrierById = (carrierId) => (
    europeanCarrierDirectory.find((carrier) => carrier.id === Number(carrierId))
);
